var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("header"),_c('v-main',[_c('div',{staticClass:"mt-24"},[_vm._t("content")],2)]),_c('v-footer',{staticClass:"d-flex flex-column",attrs:{"app":"","fixed":"","color":"white","width":"100%","padless":"","tile":""}},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }